import { Component } from "react";

export default class Progressbar extends Component {

    constructor(props) {
        super(props);

        this.update = this.update.bind(this);

        this.state = {
            timeController: 0,
            timeout: 250,
            percController: 0
        };

        this.timeoutRefresh = null;
    }

    componentDidMount() {
        this.update();
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutRefresh);
    }

    update() {
        clearTimeout(this.timeoutRefresh);

        const tick = this.state.timeout;
        const timeChangeMs = parseInt(this.props.timeChange) * 1000;
        let timeController = this.state.timeController;
        let percController = this.state.percController;
        let dispararCallback = false;

        if (this.props.play === undefined || this.props.play) {
            if (timeController > timeChangeMs) {
                timeController = 0;
                dispararCallback = true;
            } else {
                timeController = timeController + tick;
            }
            percController = timeChangeMs > 0
                ? ((parseInt(timeController) / parseInt(timeChangeMs)) * 100)
                : 0;
        } else {
            timeController = 0;
            percController = 0;
        }

        this.setState({ timeController, percController }, () => {
            if (dispararCallback && this.props.callback !== undefined) {
                this.props.callback();
            }
            this.timeoutRefresh = setTimeout(this.update, tick);
        });
    }

    render() {
        return (
            <div className="progress" style={{ height: "5px" }}>
                <div className="progress-bar" role="progressbar" aria-label="Basic example" style={{ width: parseInt(this.state.percController) + "%" }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        );
    }
}
